import React from "react";
import UserDetailsTab from "./UserDetailsTab";
import UserDetailsHeader from "./UserDetailsHeader";

const UserDetailsPage = () => {
  return (
    <UserDetailsHeader>
      <UserDetailsTab />
    </UserDetailsHeader>
  );
};

export default UserDetailsPage;
